// src/services/api.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const env = process.env
const baseUrl = process.env.REACT_APP_BASE_API_URL
console.log("connection url: " + baseUrl)
console.log(env)
export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // Get the user from the auth slice in the Redux store
      const user = getState().auth?.user;

      // If the user is logged in, add the token to the headers
      if (user?.token) {
        headers.set('authorization', `${user.token}`);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: 'users/customer/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    updateUser: builder.mutation({
      query: (body) => ({
        url: 'users/account-setting',
        method: 'PUT',
        body: body,
      }),
    }),
    createUser: builder.mutation({
      query: (userData) => ({
        url: 'users/customer/create', 
        method: 'POST',
        body: {
          ...userData,
          role_id: 6 // Force customer role I guess
        },
      }),
    }),
    resetPassword: builder.mutation({
      query: (userData) => ({
        url: 'users/customer/forgot-password',
        method: 'POST',
        body: {
          email: userData.email,
          // password: userData.password,
          type: "email"
        },
      }),
    }),
    resetPasswordOTP: builder.mutation({
      query: (userData) => ({
        url: 'users/customer/reset-password',
        method: 'POST',
        body: {
          email: userData.email,
          password: userData.password,
          otp: userData.otp,
        },
      }),
    }),
  }),
});

export const { useLoginMutation, useUpdateUserMutation, useCreateUserMutation, useResetPasswordMutation, useResetPasswordOTPMutation } = api;